import * as React from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useSwipeable } from "react-swipeable";
import { useHistory } from "react-router-dom";
import { DeviceUtil } from "../../../utils";

interface SwipeToRefreshProps {
    children: React.ReactNode;
}

const ALLOWED_PATHS = ["/reports", "/settings", "/account", "/openSourceAttribution", "/team"];

export const isSwipeBackAllowed = (): boolean => {
    const { hostname, pathname } = window.location;
    const isMobileWrapper = DeviceUtil.isMobileWrapper();
    const isArtistsDomain = hostname.endsWith("artists.amazon.com");
    const isAuthPortal = pathname.startsWith("/ap/");
    const isAllowedPath = ALLOWED_PATHS.some((p) => pathname.includes(p));
    return isMobileWrapper && isArtistsDomain && !isAuthPortal && isAllowedPath;
};

export const SwipeBackWrapper: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const history = useHistory();

    const handlers = useSwipeable({
        onSwipedRight: (eventData) => {
            const startX = eventData.initial[0];
            const isEdgeSwipe = startX <= 50;
            if (isEdgeSwipe && isSwipeBackAllowed()) {
                history.goBack();
            }
        },
        delta: 100,
        trackMouse: false,
        trackTouch: true,
        preventScrollOnSwipe: false,
    });

    return (
        <div {...handlers} style={{ minHeight: "100%" }}>
            {children}
        </div>
    );
};

export class SwipeToRefresh extends React.Component<SwipeToRefreshProps> {
    private handleRefresh = (): Promise<void> => {
        window.location.reload();
        return new Promise(() => {});
    };

    render() {
        const { children } = this.props;

        if (!DeviceUtil.isMobileWrapper()) {
            return <>{children}</>;
        }

        return (
            <div
                style={{
                    minHeight: "100vh",
                    overflowY: "auto",
                    WebkitOverflowScrolling: "touch",
                }}
            >
                <PullToRefresh onRefresh={this.handleRefresh}>
                    <>{children}</>
                </PullToRefresh>
            </div>
        );
    }
}
